/* IMPORT */
import Color from '../color/index.js';
/* MAIN */
const toHsla = (color) => {
    return Color.format.hsla.stringify(Color.parse(color));
};
/* EXPORT */
export default toHsla;
